import { Email } from "../models/Email";
import { network } from "./index";

export class SendEmail {
  static path = "/user-profile/me/email-support";
  static async send(email: Email): Promise<void> {
    await network.callPost(SendEmail.path, email.toJSON());
  }
}
